import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import useQuoteColumn from "./Hook/useQuoteColumn";
import QuoteFilter from "./QuoteFilter";
import QuoteAdvancedFilter from "./QuoteAdvancedFilter";
import { checkButtonAccess } from "../../../Utils/CommonUtils";
import { getFilteredDataWithTabs } from "../../../Utils/CommonService";
import {
  setQuoteFilterForm,
  setQuoteList,
  setQuoteSorting,
} from "../../../slices/orders/orderSlice";

function QuoteListing() {
  const dispatch = useDispatch();
  const quoteData = useSelector((state) => state.order.quoteList);
  const { quoteColumn } = useQuoteColumn(quoteData);

  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const filterApi = useSelector((state) => state.order.quoteFilter.filterApi);
  const filterForm = useSelector((state) => state.order.quoteFilter.form);
  const sortColumn = useSelector((state) => state.order.quoteSorting.column);
  const sortOrder = useSelector((state) => state.order.quoteSorting.order);
  const selectedUser = useSelector((state) => state.header.selectedUser);

  const enterpriseid = localStorage.getItem("enterpriseid");
  const userid = localStorage.getItem("userId");

  const canCreateQuote = checkButtonAccess("CREATE", "ORD_QUOTE");

  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);
  const handleOpen = () => setOffcanvasOpen(true);
  const handleClose = () => setOffcanvasOpen(false);

  const agId =
    selectedUser.entitytype === "AGRP" ? selectedUser.entityid : null;

  useEffect(() => {
    dispatch(setQuoteFilterForm({ type: "reset" }));
  }, []);

  return (
    <div>
      <CommonHeader
        newButton={canCreateQuote}
        buttonTitle={"Add Quote"}
        formLink="/order/quotes/create"
        filterComponent={<QuoteFilter />}
        dash={true}
        filterIcon={true}
        offcanvasopen={handleOpen}
      />
      <div>
        <TableWrapper
          columns={quoteColumn}
          data={quoteData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"QOT"}
          filterApiListEntity={"QOT"}
          filterApiFunction={setQuoteList}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setQuoteSorting}
          enterpriseId={enterpriseid}
          userId={userid}
          agId={agId}
        />
      </div>
      <QuoteAdvancedFilter show={isOffcanvasOpen} onClose={handleClose} />
    </div>
  );
}

export default QuoteListing;
